/*
 * MDB shim for MDBBtnGroup
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 */

import MUIButtonGroup from "@mui/material/ButtonGroup";

export default function MDBBtnGroup({
  children,
  vertical,
  className,
  style,
  ...rest
}) {
  return (
    <MUIButtonGroup
      orientation={vertical ? "vertical" : "horizontal"}
      className={className}
      style={style}
      {...rest}
    >
      {children}
    </MUIButtonGroup>
  );
}
